import { PortalModal } from "@/components/ui/portal-modal";
import { useRefreshAntibotClearance } from "@/hooks";

export const AntiBotRefreshClearanceModal = () => {
  const { isRefreshingClearance } = useRefreshAntibotClearance();
  const handleOpenChange = () => undefined;

  return (
    <PortalModal
      open={isRefreshingClearance}
      onOpenChange={handleOpenChange}
      disableBackdropClick
      showCloseButton={false}
      className="sm:max-w-[480px]"
    >
      <PortalModal.Content className="items-center gap-6 text-center">
        <h3 className="text-xl font-semibold text-cede-text-primary">Checking the validity of your session...</h3>
        <div
          id="anti-bot-refresh-clearance"
          className="flex min-h-20 w-full items-center justify-center"
          aria-live="polite"
        />
      </PortalModal.Content>
    </PortalModal>
  );
};
